/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Box, Button, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { nextStep, setAddress, setStepVerified } from '../habitationSlice';
import { useTranslation } from 'react-i18next';
import AddressInput, { Address } from '@/components/common/AddressInput';
import { HabitationAddressFields } from '../components/HabitationAddressFields';
import { trackEvent } from '@/utils/trackEvent';

const EMPTY_ADDRESS: Address = {
  street: '',
  postalCode: '',
  city: '',
  country: '',
};


const StyledButton = styled(Button)`
  margin-top: 85px;
  width: 160px;
  border-radius: 20px;
  background-color: #2F6472;
  &:hover {
    background-color: white;
    color: #2F6472;
  }
`;

const StyledContainerButton = styled.div`
  text-align: center;
`;

const ErrorText = styled.p`
  color: red;
  font-size: 0.9rem;
  margin-top: 8px;
  text-align: center;
`;

const AddressStep: React.FC = () => {
  const dispatch = useAppDispatch();
  const address = useAppSelector((state) => state.habitation.address);
  const [error, setError] = useState('');
  const { t } = useTranslation('habitation');


  const isAddressValid = (addr = address) => {
    return !!addr?.street && !!addr?.postalCode && !!addr?.city;
  };


  const handleNext = () => {
    if (!isAddressValid()) {
      setError(t('step1.address.error') || 'Merci de renseigner une adresse complète.');
      return;
    }
    else {
        setError('');
    }

    trackEvent('housing_step_validated', {
      step: 'address',
      location_hint: `${address?.postalCode} ${address?.city}`
    });

    dispatch(setStepVerified(1));
    dispatch(nextStep());
  };

  return (
    <Box sx={{ maxWidth: 800, margin:{ xs: '0 auto', sm: '0 100px'}, padding: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        {t('step1.address.title')}
      </Typography>

      {/* `limitFrenchCountry` : l'adresse est ici celle du LOGEMENT assuré, et
          Studcorp n'assure que des logements en France. Rien à voir avec
          l'adresse de résidence d'un étudiant, qui est ouverte au monde
          entier depuis STU-28. */}
      <HabitationAddressFields>
        <AddressInput
          value={address ?? EMPTY_ADDRESS}
          onChange={(addr) => dispatch(setAddress(addr))}
          limitFrenchCountry
        />
      </HabitationAddressFields>

      {error && <ErrorText>{error}</ErrorText>}

      <StyledContainerButton>
        <StyledButton variant="contained" fullWidth onClick={handleNext}>
          {t('step1.next')}
        </StyledButton>
      </StyledContainerButton>
    </Box> 
  );
};


export default AddressStep;
